import { defineStore } from 'pinia'

export const useControlPanelStore = defineStore('controlPanel', {
  state: () => {
    return {
      inEditMode: false,
      markedBoxes: [],
      parkedBoxes: [],
      items: []
    }
  },
  getters: {
    /**
     * marked and parked
     */
    hiddenBoxes() {
      return [...this.markedBoxes, ...this.parkedBoxes]
    },
    hiddenIds() {
      return this.hiddenBoxes.map((i) => i.lookupDashboardTypesId)
    },
    itemsForDisplay() {
      if (this.hiddenIds.length === 0) return this.items

      return this.items.filter((i) => this.hiddenIds.includes(i.lookupDashboardTypesId) === false)
    }
  },
  actions: {
    markForRemoval(item) {
      this.markedBoxes.push(item)
    },
    exitEditMode() {
      this.inEditMode = false
    },
    onSaveLayout() {
      this.parkedBoxes = [...this.parkedBoxes, ...this.markedBoxes]
      this.onCancel()
    },
    onCancel() {
      this.markedBoxes = []
      this.exitEditMode()
    },
    restoreBox(item) {
      this.parkedBoxes = this.parkedBoxes.filter(
        (i) => i.lookupDashboardTypesId != item.lookupDashboardTypesId
      )

      this.markedBoxes = this.markedBoxes.filter(
        (i) => i.lookupDashboardTypesId != item.lookupDashboardTypesId
      )
    }
  },
  persist: true
})
